/**
 * WeaponTrident — wide three-pronged polearm.
 * Tall shaft with three prongs at the tip. Extends above the sprite (overflow visible).
 * Renders as an SVG <g> group in the knight's coordinate space (25×25).
 */
export default function WeaponTrident() {
  return (
    <g>
      {/* Main shaft */}
      <rect x="22"   y="2"    width="1.5" height="20"  rx="0.5" fill="#8ab0cc"/>
      {/* Center prong — tallest */}
      <rect x="22"   y="-3"   width="1.5" height="7"   rx="0.4" fill="#c0dce8"/>
      {/* Left prong */}
      <rect x="18.5" y="-1"   width="1.2" height="5"   rx="0.4" fill="#c0dce8"/>
      {/* Right prong */}
      <rect x="26"   y="-1"   width="1.2" height="5"   rx="0.4" fill="#c0dce8"/>
      {/* Connecting bar between prongs */}
      <rect x="18"   y="3.5"  width="10.5" height="1"  rx="0.3" fill="#8ab0cc"/>
      {/* Shaft butt-cap */}
      <rect x="21.8" y="21"   width="2"   height="1.5" rx="0.4" fill="#6a8098"/>
    </g>
  );
}
